import { connect } from 'react-redux';
import CorrectionReadyProductsTable from './CorrectionReadyProductsTable';
import { inputReadyProducts, updateReadyProducts } from '../../../store/actions/inputReadyProducts';
import {
  getReadyProducts,
  deleteReadyProducts,
  sendForMounting, deleteReadyProductsMultiple
} from '../../../store/actions/correctionReadyProducts';
import {
  clearCorrectionSemiProductsClear,
  getSemiProductByReady,
  getCorrectionSemi
} from '../../../store/actions/correctionSemiProducts';

const mapStateToProps = ({
  correctionReadyProductsReducer,
  tabsReducer,
  inputReadyProductReducer
}) => ({
  correctionReadyProductsReducer,
  tabsReducer,
  inputReadyProductReducer
});
const mapDispatchToProps = {
  inputReadyProducts,
  updateReadyProducts,
  getReadyProducts,
  getSemiProductByReady,
  deleteReadyProducts,
  deleteReadyProductsMultiple,
  clearCorrectionSemiProductsClear,
  getCorrectionSemi,
  sendForMounting
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CorrectionReadyProductsTable);
